import Cookies from "js-cookie";
import { forwardRef, useState, useImperativeHandle } from "react";
import { Input, Modal, Form, Row, Col, Button, message } from "antd";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as CloseIcon } from "@/assets/icons/closeicon.svg";
import { requestSmsCode, resetPassword } from "@/services/api";
import api_domain_config from "@/config/config";
import { ReactComponent as PasswordHide } from "@/assets/icons/hidepassword.svg";
import { ReactComponent as PasswordShow } from "@/assets/icons/showpassword.svg";
import rules from "@/config/rules";

/**
 * 修改密码弹窗组件
 * @param {Function} handlePhoneBind 手机号绑定事件
 * @returns
 */
const UpdatePasswordModal = forwardRef(({ handlePhoneBind }, ref) => {
  const [updatePwdModalVisibleObj, setUpdatePwdModalVisibleObj] = useState({}); //是否打开修改密码弹窗
  const [submitLoading, setSubmitLoading] = useState(false);
  const [isShowCode, setIsShowCode] = useState(false);
  const navigate = useNavigate();
  const [time, setTime] = useState(60);
  const [form] = Form.useForm();

  useImperativeHandle(ref, () => {
    return {
      setModalVisible: (flag, phone) => {
        setUpdatePwdModalVisibleObj({ open: flag, phone: phone });
      },
    };
  });

  /**
   * 请求修改密码表单提交
   * @param {Object} params
   */
  const requestEditPassword = (params) => {
    setSubmitLoading(true);
    params = {
      ...params,
      scene: 1,
    };
    resetPassword(params).then((res) => {
      if (res.code === 200) {
        message.success("已修改成功，请重新登录");
        //删除当前用户登录的信息
        Cookies.remove("authorization", { domain: api_domain_config.DOMAIN });
        localStorage.removeItem("currentUserInfo");
        localStorage.removeItem("isSignin");
        //密码修改成功一秒后自动跳转首页去登录
        setTimeout(() => {
          window.location.replace("https://www.niuxuezhang.cn");
        }, 1000);
      }
      setSubmitLoading(false);
    });
  };

  /**
   * 发送验证码
   * @returns
   */
  const sendCode = async () => {
    if (isShowCode) {
      // 倒计时未结束,不能重复点击
      return;
    }
    const params = {
      type: 1,
      scene: 4,
      phone: updatePwdModalVisibleObj?.phone,
      brand_id: 7,
    };
    try {
      const { code } = await requestSmsCode(params);
      if (code === 200) {
        setIsShowCode(true);
        // 倒计时
        const active = setInterval(() => {
          setTime((preSecond) => {
            if (preSecond <= 1) {
              setIsShowCode(false);
              clearInterval(active);
              // 重置秒数
              return 60;
            }
            return preSecond - 1;
          });
        }, 1000);
      }
    } catch (error) {
      console.log(error);
    }
  };

  /**
   * 自定义密码显示和隐藏icon
   * @param {*} visible
   */
  const passWordIconRender = (visible) =>
    visible ? <PasswordShow /> : <PasswordHide />;

  const validatePasswordRule = (rule, value, callback) => {
    if (form.getFieldValue("password") !== value) {
      callback(rule.message);
    } else {
      callback();
    }
  };

  return (
    <>
      <Modal
        title={false}
        open={updatePwdModalVisibleObj.open}
        maskClosable={false}
        onCancel={() => setUpdatePwdModalVisibleObj({ open: false })}
        footer={false}
        closeIcon={<CloseIcon />}
        width={508}
        centered
        className="update_paddword_modal"
      >
        <h4 className="title">
          {updatePwdModalVisibleObj?.phone ? "修改密码" : "手机号码绑定"}
        </h4>
        {updatePwdModalVisibleObj?.phone ? (
          <Form
            name="form"
            form={form}
            onFinish={requestEditPassword}
            validateTrigger="onBlur"
            autoComplete="off"
            className="text-start mt-lg-4"
          >
            <Form.Item label="">
              <Row justify="space-between">
                <Col xs={13} md={15}>
                  <Form.Item
                    name="code"
                    noStyle
                    rules={[{ required: true, message: "请输入您的验证码!" }]}
                  >
                    <Input placeholder="验证码" />
                  </Form.Item>
                </Col>
                <Col xs={10} md={8} className="text-end">
                  <Button
                    type="primary"
                    ghost
                    className="sms_code"
                    onClick={sendCode}
                    disabled={isShowCode ? true : false}
                  >
                    {isShowCode ? `${time}秒后重试` : "获取验证码"}
                  </Button>
                </Col>
              </Row>
            </Form.Item>
            <Form.Item
              name="password"
              className="require_item require-password"
              rules={[
                { required: true, message: "请输入您的新密码!" },
                {
                  pattern: new RegExp(rules.password),
                  message:
                    "密码格式错误，8~20位字符，必须包含数字与字母，不允许出现中文与空格。",
                },
              ]}
            >
              <Input.Password
                placeholder="请输入您的新密码"
                iconRender={passWordIconRender}
              />
            </Form.Item>
            <Form.Item
              name="password_confirmation"
              className="require_item"
              rules={[
                {
                  required: true,
                  message: "两次密码不一致,请重新输入",
                  validator: validatePasswordRule,
                },
              ]}
            >
              <Input.Password
                placeholder="确认密码"
                iconRender={passWordIconRender}
              />
            </Form.Item>
            <Form.Item className="text-center mb-3">
              <Button
                className="ant-btn ant-btn-primary ant-btn-lg w-100 submitButton fs-5 fw-normal"
                htmlType="submit"
                loading={submitLoading}
              >
                确定
              </Button>
            </Form.Item>
          </Form>
        ) : (
          <div className="text-center">
            <p style={{ fontSize: "1rem" }} className="text-start bind-phone-text">
              为保障您的账户安全，请先绑定手机号码，再进行密码修改操作！
            </p>
            <Button
              className="btn btn-lg phoneBindBtn"
              type="primary"
              onClick={handlePhoneBind}
            >
              手机号码绑定
            </Button>
          </div>
        )}
      </Modal>
    </>
  );
});

export default UpdatePasswordModal;
